import SubText from "components/shared/SubText";
import { decodeHtmlEntities } from "constant/htmlEntities";
import { useSelector } from "react-redux";
import ShareButton from "./ShareButton";
import AddToFavCreator from "./AddToFavCreator";
import VideoDetailsSkeleton from "components/skeleton/VideoDetailsSkeleton";

const VideoCreatorDetails = ({ videoDetails, isLoading }: any) => {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const baseUrl = window.location.origin;
  const currentUrl = baseUrl + window.location.pathname;
  const { currentVideo } = useSelector((state: any) => state?.video);

  return (
    <>
      {isLoading ? (
        <div className="w-full mt-5 max-sm:ml-3">
          <div className="flex w-full items-start justify-between gap-4 max-sm:block max-sm:w-[98%]">
            <div className="min-w-0">
              <SubText text={currentVideo?.title} />
            </div>
            <div className="flex shrink-0 items-center gap-4 max-sm:mt-3">
              <AddToFavCreator
                loggedInUser={loggedInUser}
                video={currentVideo}
              />
              <ShareButton shareUrl={currentUrl} />
            </div>
          </div>

          <div className="mt-5">
            <p
              className="w-full text-[14px] leading-relaxed text-white/70"
              dangerouslySetInnerHTML={{
                __html:
                  decodeHtmlEntities(currentVideo?.description),
              }}
            />
          </div>
        </div>
      ) : (
        <VideoDetailsSkeleton />
      )}
    </>
  );
};

export default VideoCreatorDetails;